module.exports = __webpack_public_path__ + "img/startcamel-space.87959537.png";